import React from 'react';
import config from '@alphapoint/apex-web/lib/config';
import { getBEMClasses } from '../../helpers/cssClassesHelper';
import PrivacyIcon from './privacy.svg';
import TermsIcon from './terms.svg';
import './PrivacyTermsLinks.css';

const baseClass = getBEMClasses('privacy-terms-links');

export const PrivacyTermsLinks = () => {
  const openInNewWindow = config.Footer.openInNewWindowGlobal || true;
  const termsAndServicesLink =
    config.Footer.links[0][0].link || 'https://exchange.svc.apglobal.io/TermsAndConditions.pdf';
  const privacyPolicyLink = config.Footer.links[0][1].link || 'https://exchange.svc.apglobal.io/PrivacyPolicy.pdf';
  return (
    <div className={baseClass()}>
      <a
        className={baseClass('button')}
        target={openInNewWindow ? '_blank' : ''}
        rel={openInNewWindow ? 'noopener noreferrer' : ''}
        href={privacyPolicyLink}>
        <img src={PrivacyIcon} alt="Privacy Policy" className={baseClass('button-icon')} />
        <div className={baseClass('button-text')}>Privacy Policy</div>
      </a>
      <a
        className={baseClass('button')}
        target={openInNewWindow ? '_blank' : ''}
        rel={openInNewWindow ? 'noopener noreferrer' : ''}
        href={termsAndServicesLink}>
        <img src={TermsIcon} alt="Terms and Conditions" className={baseClass('button-icon')} />
        <div className={baseClass('button-text')}>Terms and Conditions</div>
      </a>
    </div>
  );
};
